import { render, staticRenderFns } from "./HelloUser.vue?vue&type=template&id=4ef2833a&"
import script from "./HelloUser.vue?vue&type=script&lang=js&"
export * from "./HelloUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports